import apiClient from '@/core/api/client';
import { API_ENDPOINTS } from '@/core/api/endpoints';
import { ApiResponse } from '@/core/api/types';
import { LoginDto, AuthResponse } from '../types';

/**
 * Authentication Service
 * Handles all auth related API calls
 */
export const authService = {
    /**
     * Login user
     */
    login: async (credentials: LoginDto, schoolSlug?: string | null): Promise<ApiResponse<AuthResponse>> => {
        const url = schoolSlug 
            ? `${API_ENDPOINTS.AUTH.LOGIN}?school_slug=${schoolSlug}`
            : API_ENDPOINTS.AUTH.LOGIN;

        const response = await apiClient.post<ApiResponse<AuthResponse>>(
            url,
            credentials
        );
        return response.data;
    },


    logout: async (): Promise<ApiResponse<void>> => {
        const response = await apiClient.post<ApiResponse<void>>(API_ENDPOINTS.AUTH.LOGOUT);
        return response.data;
    },

    /**
     * Logout user
     * Client-side only logout since backend API is not available
     */
    // logout: async (): Promise<ApiResponse<void>> => {
    //     return {
    //         success: true,
    //         data: null,
    //         message: 'Logged out locally',
    //         error: null
    //     };
    // },

    /**
     * Refresh token
     */
    refreshToken: async (refreshToken: string): Promise<ApiResponse<{ access_token: string }>> => {
        const response = await apiClient.post<ApiResponse<{ access_token: string }>>(
            API_ENDPOINTS.AUTH.REFRESH,
            { refresh_token: refreshToken }
        );
        return response.data;
    },

    /**
     * Reset/Set Password
     */
    resetPassword: async (token: string, newPassword: string, schoolSlug: string): Promise<ApiResponse<void>> => {
        const response = await apiClient.post<ApiResponse<void>>(
            `${API_ENDPOINTS.AUTH.RESET_PASSWORD}?school_slug=${schoolSlug}`,
            { new_password: newPassword },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }
        );
        return response.data;
    },

    /**
     * Request Password Reset Link
     */
    forgotPassword: async (email: string, schoolSlug?: string | null): Promise<ApiResponse<void>> => {
        const url = schoolSlug 
            ? `${API_ENDPOINTS.AUTH.FORGOT_PASSWORD}?school_slug=${schoolSlug}`
            : API_ENDPOINTS.AUTH.FORGOT_PASSWORD;

        const response = await apiClient.post<ApiResponse<void>>(
            url,
            { email }
        );
        return response.data;
    },

    /**
     * Get Public School Config for Tenant Login
     */
    getPublicSchoolConfig: async (slug: string): Promise<ApiResponse<any>> => {
        const response = await apiClient.get<ApiResponse<any>>(
            API_ENDPOINTS.SCHOOLS.PUBLIC(slug)
        );
        return response.data;
    },
};

export default authService;
